module.exports = __webpack_public_path__ + "img/app-choice-assistant.c96e1d7a.webp";